import { sonic } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createSonicChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}) =>
  createSonicChainCustom({
    client: createClient({
      chain: sonic,
      httpRpcs: sonicHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'SonicScan',
      baseUrl: 'https://sonicscan.org',
      chainId: 146,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateSonicChainParameters = {
  client: Client
  explorer: Explorer
}

export const createSonicChainCustom = ({
  client,
  explorer,
}: CreateSonicChainParameters): Chain => ({
  id: 146,
  network: 'sonic',
  name: 'Sonic',
  nativeToken: {
    name: 'Sonic',
    symbol: 'S',
    decimals: 18,
    currency: {
      type: 'CryptoCurrency',
      id: 'sonic-3',
      name: 'Sonic',
      symbol: 'S',
      market: {
        coingeckoId: 'sonic-3',
      },
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'sonic',
  defillamaId: 'sonic',
})

export const sonicHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.soniclabs.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://sonic.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://sonic.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const sonicWebsocketRpcUrls: readonly string[] = [
  'wss://sonic.drpc.org',
  'wss://rpc.ankr.com/sonic_mainnet/ws',
  'wss://sonic.callstaticrpc.com',
]
